// @flow
export { default } from './OrderTaxTemplate';



// WEBPACK FOOTER //
// ./src/components/order/OrderTaxTemplate/index.js